import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {TextField} from '@material-ui/core';
import axios from 'axios'
import CircularProgress from '@material-ui/core/CircularProgress';
import { toast } from 'react-toastify';

import { Container } from './styles.js';
import avatar from '../../../assets/images/avatar.png'
import history from '../../../services/history'

function App() {
  const [empresas, setEmpresas] = useState([{
    empresa:'',
    id:''
  }]);
  const [loading,setLoading] = useState(false)

  useEffect(() => {
    async function load() {
      setLoading(true)      
      const response = await axios.get(process.env.REACT_APP_API+'/empresasList');
      setEmpresas(response.data);
      setLoading(false)
    }
    load();
  }, []);

  const { register, handleSubmit, errors } = useForm();

  const onSubmit = async ({company,username,password}) => {
    if(loading){
      toast.error('Falha ao conectar com o banco de dados')
      return;
    }
    try{
      var codeCompany = company.split(' - ')[0]
      console.log(codeCompany)
      const response = await axios.post(process.env.REACT_APP_API+'/login',{
        company:codeCompany,
        username,
        password
      })
      const {token} = response.data;
      localStorage.setItem('JWTANF', token)
      history.push('/')
    }catch(error){
      toast.error('Falha na autentificação, verifique seus dados')
    }
  };

  return (
      <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <img src={avatar} alt="Avatar" />
          </div>
            <Autocomplete
            autoComplete
            autoHighlight
            options={empresas}
            getOptionLabel={(option) => option.empresa}
            loading={loading}
            renderInput={(params) => (
              <TextField {...params} name="company" label="Cod-Empresa" variant="outlined"  size="small"
              inputRef={register({ required: true })}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
             />
            )}
          />
           {errors.company && <span>Código da empresa é obrigatório</span>}
          <TextField  name="username" label="Usuário" variant="outlined"  size="small"
          inputRef={register({ required: true })}/>
          {errors.username && <span>Usuário é obrigatório</span>}
          <TextField name="password" 
            type="password" 
            label="Senha" 
            variant="outlined" 
            size="small"
            inputRef={register({ required: true })}/> 
          {errors.password && <span>A senha é obrigatória</span>}
          <button type="submit">Logar</button>
        </form>
      </Container>
  );
}

export default App;
